import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, isDevMode } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { API_CONFIG } from '@asset-solutions/shared/http';
import { provideLogger } from '@asset-solutions/shared/logging';

import { appRoutes } from './app.routes';
import { ErrorHandlerService } from './logging/error-handler';
import { CustomerTrackingServerLogger } from './logging/server-logger.service';

export const appConfig: ApplicationConfig = {
  providers: [
    // Providers from legacy modules
    importProvidersFrom(MatSnackBarModule, MatDialogModule),

    // Angular providers
    provideHttpClient(),
    provideRouter(appRoutes, withComponentInputBinding()),

    // Internal providers
    provideLogger(
      { logToConsole: isDevMode(), logToServer: !isDevMode() },
      { customServerLogger: CustomerTrackingServerLogger }
    ),
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    { provide: API_CONFIG, useValue: { url: '/api' } }
  ]
};
